import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  fullScreen?: boolean;
  className?: string;
}

export function LoadingSpinner({ fullScreen = false, className }: LoadingSpinnerProps) {
  if (fullScreen) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className={cn('h-8 w-8 animate-spin text-muted-foreground', className)} />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-10">
      <Loader2 className={cn('h-8 w-8 animate-spin text-muted-foreground', className)} />
    </div>
  );
}
